import type { TransactionType } from "../../lib/types";

export type RecordMode = "active" | "deleted";

export type RecordFilters = {
  type: TransactionType | "linked" | "";
  categoryId: string;
  uncategorized: boolean;
  userId: string;
  accountId: string;
  tagIds: string[];
  dateFrom: string;
  dateTo: string;
};

export function emptyRecordFilters(): RecordFilters {
  return { type: "", categoryId: "", uncategorized: false, userId: "", accountId: "", tagIds: [], dateFrom: "", dateTo: "" };
}
